// User with the 'none' role details interface

import { useFirebase } from './FirebaseContextProvider';
import UserCardTemplate from './UserCardTemplate';
import PropItem from './PropItem';
import PropItemsBlock from './PropItemsBlock';
import NoneCardEdit from './NoneCardEdit';
import placeholderPerson from '../assets/images/placeholder-person.png';

export default function NoneCard({ none }) {
  const { user } = useFirebase();

  const { id, name, phone, email } = none;

  const isTheUser = user.id === id;

  return (
    <UserCardTemplate
      header='None role'
      className='none-card'
      backBtn={!isTheUser}
      isTheUser={isTheUser}
      imgPath={none.imgPath}
      imgThumbPath={none.imgThumbPath}
      imgTitle={name}
      name={name}
      placeholder={placeholderPerson}
      details={
        <PropItemsBlock>
          <PropItem prop='Phone' value={phone} />
          <PropItem prop='e-mail' value={email} />
          <p className='font-16 font-medium'>
            You need an invitation to get a role
            <br />
            Please ask for an invitation from your coach or administrator
          </p>
        </PropItemsBlock>
      }
      editForm={isTheUser && <NoneCardEdit none={none} />}
    />
  );
}
